module.exports = __webpack_public_path__ + "img/pinterest-social-logo-svgrepo-com.b8caadd1.svg";